<template>
  <div>
    <RowCard :multiLineNoPadding="true" theme="none" :key="i" style="position: relative">
      <div :style="{ width: headers[0].width }" class="d-flex justify-center ">
        <v-btn class="btn-custom" small icon @click="onEdit">
          <Iconify icon="material-symbols:edit" class="theme-color-seven" size="15px"></Iconify>
        </v-btn>
        <v-btn class="btn-custom" small icon @click="onDelete(item.id)">
          <Iconify style="color: #b1b1b1" icon="basil:trash-alt-solid" size="15px"></Iconify>
        </v-btn>
      </div>
      <div :style="{ width: headers[1].width, textAlign: headers[1].align }">
        {{ item.no }}
      </div>
      <div :style="{ width: headers[2].width, textAlign: headers[2].align }">
        <div>
          {{ item.projectCode }}
        </div>
      </div>
      <div :style="{ width: headers[3].width, textAlign: headers[3].align }" :class="{ 'theme-color-seven': redText }"
        class="one-line" style="height: 20px">
        <tooltip-text :text="item.projectName
          " />
      </div>
      <div :style="{ width: headers[4].width, textAlign: headers[4].align }" class="one-line" style="height: 20px">
        {{ item.fiscalYear }}
      </div>
      <!--   RSP   -->
      <div class="one-line" style="height: 20px" :style="{ width: headers[5].width, textAlign: headers[5].align }">
        {{ item.plan }}
      </div>
      <div class="one-line" style="height: 20px" :style="{ width: headers[6].width, textAlign: headers[6].align }">
        {{ item.researcher }}

      </div>
      <div class="one-line" style="height: 20px" :style="{ width: headers[7].width, textAlign: headers[7].align }">

        <div class="d-flex justify-center">

          <v-btn class="btn-custom" small icon @click="onPreview">
            <Iconify icon="carbon:view-filled" size="15px"></Iconify>
          </v-btn>
        </div>
      </div>
      <div class="one-line" style="height: 20px" :style="{ width: headers[8].width, textAlign: headers[8].align }">
        <div class="d-flex justify-center">
          <v-btn absolute top right icon :class="{ rotate180: isExpanded }" @click="seeDetail">
            <Iconify icon="material-symbols:keyboard-arrow-down" color="#D3D3D3"></Iconify>
          </v-btn>
        </div>

      </div>

    </RowCard>
    <div class="expand-layout px-5" :class="[rand]">
      <div class="expand-content d-flex flex-column height-max">
        <div class="d-flex justify-space-between w-100 height-max">
          <div class="d-flex w-100" style="gap: 12px">
            <RowCard :multiLineNoPadding="true" theme="none">
              <div class="d-flex w-100" style="gap: 12px">
                <div class="" :style="{ width: '8%' }">
                  <v-btn class="btn-custom" small icon @click="onEdit">
                    <Iconify icon="material-symbols:edit" class="theme-color-seven" size="15px"></Iconify>
                  </v-btn>
                </div>
                <div class="" :style="{ width: '15%' }">

                  TL
                </div>
                <div class="" :style="{ width: '52%' }">
                  Lorem ipsum dolor sit amet.
                  Lorem ipsum dolor sit amet.
                  Lorem ipsum dolor sit amet.
                </div>
                <div class="" :style="{ width: '24%' }">

                  Lorem ipsum dolor sit amet.
                  Lorem ipsum dolor sit amet.
                  Lorem ipsum dolor sit amet.
                </div>
              </div>
            </RowCard>
          </div>
        </div>
        <div class="d-flex my-2">
          <Iconify icon="material-symbols:edit" color="var(--theme-color-eight)"></Iconify>
          <div class="ml-2 ">
            แก้ไข
          </div>
        </div>
        <div class="d-flex w-100" style="gap: 12px">
          <div class="" :style="{ width: '75%', marginRight: '72px' }">
            <label>เทคโนโลยีหลักที่นำมาใช้ ตัวที่ 1</label>
            <TextField theme="3" :value="form.fiscal_year" @onChange="form.fiscal_year = $event"
              :rules="[(v) => !!v || 'กรุณาระบุปีงบประมาณ']" />
          </div>
          <div class="">
            <label>ระดับ TRL (ระดับ 1-9)</label>
            <SelectBox placeholder="แผนงาน" theme="3" item-text="name" item-value="value" dense :items="monthList"
              @onChange="form.plan = $event" :rules="[(v) => !!v || 'กรุณาระบุแผนงาน']" />
          </div>
        </div>
        <div class="d-flex w-100">
          <div class="" :style="{ width: '75%', marginRight: '72px' }">
            <label>เทคโนโลยีหลักที่นำมาใช้ ตัวที่ 2</label>
            <TextField theme="3" :value="form.fiscal_year" @onChange="form.fiscal_year = $event"
              :rules="[(v) => !!v || 'กรุณาระบุปีงบประมาณ']" />
          </div>
          <div class="">
            <label>ระดับ TRL (ระดับ 1-9)</label>
            <SelectBox placeholder="แผนงาน" theme="3" item-text="name" item-value="value" dense :items="monthList"
              @onChange="form.plan = $event" :rules="[(v) => !!v || 'กรุณาระบุแผนงาน']" />
          </div>
        </div>
        <div class="d-flex w-100" style="gap: 12px">
          <div class="" :style="{ width: '75%', marginRight: '72px' }">
            <label>เทคโนโลยีหลักที่นำมาใช้ ตัวที่ 3</label>
            <TextField theme="3" :value="form.fiscal_year" @onChange="form.fiscal_year = $event"
              :rules="[(v) => !!v || 'กรุณาระบุปีงบประมาณ']" />
          </div>
          <div class="">
            <label>ระดับ TRL (ระดับ 1-9)</label>
            <SelectBox placeholder="แผนงาน" theme="3" item-text="name" item-value="value" dense :items="monthList"
              @onChange="form.plan = $event" :rules="[(v) => !!v || 'กรุณาระบุแผนงาน']" />
          </div>
        </div>
        <label>ประเภทโครงการย่อย</label>
        <v-radio-group v-model="form.form_type" row label="" @change="form.form_c_id = ''">
          <v-radio label="Form C" value="c" color="var(--theme-color-one)"></v-radio>
          <v-radio label="Form D" value="d" color="var(--theme-color-one)"></v-radio>
          <v-radio label="Form F" value="f" color="var(--theme-color-one)"></v-radio>
        </v-radio-group>
        <div class="d-flex justify-end to-hide my-3 gap-12">
          <Button theme="2" @onClick="onCancel()">ยกเลิก</Button>
          <div class="flex-center" v-if="!$route.query.preview">
            <Button theme="6" :disabled="isLoading || doNotSubmit" @onClick="nextForm">
              บันทึก
            </Button>
          </div>
        </div>
        <div class="d-flex flex-column gap-12">
          <RowCard :multiLineNoPadding="true" theme="none">
            <div class="d-flex w-100" style="gap: 12px">
              <div class="" :style="{ width: '8%' }">
                <v-btn class="btn-custom" small icon @click="onEdit">
                  <Iconify icon="material-symbols:edit" class="theme-color-seven" size="15px"></Iconify>
                </v-btn>
              </div>
              <div class="" :style="{ width: '15%' }">

                TL
              </div>
              <div class="" :style="{ width: '52%' }">
                Lorem ipsum dolor sit amet.
                Lorem ipsum dolor sit amet.
                Lorem ipsum dolor sit amet.
              </div>
              <div class="" :style="{ width: '24%' }">

                Lorem ipsum dolor sit amet.
                Lorem ipsum dolor sit amet.
                Lorem ipsum dolor sit amet.
              </div>
            </div>
          </RowCard>
          <RowCard :multiLineNoPadding="true" theme="none">
            <div class="d-flex w-100" style="gap: 12px">
              <div class="" :style="{ width: '8%' }">
                <v-btn class="btn-custom" small icon @click="onEdit">
                  <Iconify icon="material-symbols:edit" class="theme-color-seven" size="15px"></Iconify>
                </v-btn>
              </div>
              <div class="" :style="{ width: '15%' }">

                TL
              </div>
              <div class="" :style="{ width: '52%' }">
                Lorem ipsum dolor sit amet.
                Lorem ipsum dolor sit amet.
                Lorem ipsum dolor sit amet.
              </div>
              <div class="" :style="{ width: '24%' }">

                Lorem ipsum dolor sit amet.
                Lorem ipsum dolor sit amet.
                Lorem ipsum dolor sit amet.
              </div>
            </div>
          </RowCard>
          <RowCard :multiLineNoPadding="true" theme="none">
            <div class="d-flex w-100" style="gap: 12px">
              <div class="" :style="{ width: '8%' }">
                <v-btn class="btn-custom" small icon @click="onEdit">
                  <Iconify icon="material-symbols:edit" class="theme-color-seven" size="15px"></Iconify>
                </v-btn>
              </div>
              <div class="" :style="{ width: '15%' }">

                TL
              </div>
              <div class="" :style="{ width: '52%' }">
                Lorem ipsum dolor sit amet.
                Lorem ipsum dolor sit amet.
                Lorem ipsum dolor sit amet.
              </div>
              <div class="" :style="{ width: '24%' }">

                Lorem ipsum dolor sit amet.
                Lorem ipsum dolor sit amet.
                Lorem ipsum dolor sit amet.
              </div>
            </div>
          </RowCard>
        </div>
      
      </div>
    </div>
  </div>
</template>

<script>
import Button from "./input/Button";
import RowCard from "../components/RowCard";
import { toDateFormat, formatNumber } from "@/plugins/global-funcs";
import { mapState } from "vuex";
import TextField from "../components/input/TextField"
import SelectBox from "../components/input/SelectBox";

export default {
  name: "TechEvalItem",
  components: {
    Button,
    RowCard,
    TextField,
    SelectBox,
  },
  props: {
    item: {
      default: () => ({}),
    },
    index: {
      default: 0,
    },
    headers: {
      default: () => [],
    }
  },
  data() {
    return {
      toDateFormat,
      formatNumber,
      theme: 2,
      form: {},
      redText: false,
      rand: "cl-" + Math.random().toString().slice(2),
      isExpanded: false,
    };
  },
  // computed: {
  //   ...mapState({
  //     isRSP: (state) => state.Auth.User.user_type === "RSP",
  //     isUSP: (state) => state.Auth.User.user_type === "USP",
  //     isOIC: (state) => state.Auth.User.user_type === "สป.อว.",
  //   }),
  // },
  methods: {
    onEdit() {
      this.$router.push({
        name: "TechnologyEvaluationEdit",
        //  query: { id: this.item.id } 
      });
    },
    onUpdate(status) {
      // this.$emit("onUpdateStatus", status);
    },
    seeDetail() {
      let growDiv = document.querySelector("." + this.rand + ".expand-layout");
      if (growDiv.clientHeight) {
        growDiv.style.height = 0;
        this.isExpanded = false;
      } else {
        let wrapper = document.querySelector(
          "." + this.rand + " .expand-content"
        );
        growDiv.style.height = wrapper.clientHeight + 20 + "px";
        this.isExpanded = true;
      }
    },
    onDelete(id) {
      // sweetalert confirm
      this.$store.commit("General/setModal", {
        theme: "delete",
        title: "ลบข้อมูล ?",
        text: "ท่านยืนยันที่จะลบข้อมูลหรือไม่?",
        buttonText: "ยืนยัน",
        cancelText: "ยกเลิก",
        action: async () => {
          let res = await this.$apiFire("TechnologyEvaluation/delete", id);
          if (res) {
            // this.$store.commit("General/setModal", {
            //   title: "เสร็จสิ้น!",
            //   theme: "success",
            //   text: res,
            //   showCancel: false,
            // });
            window.location.reload();
          }
        },
      });
    },
    onPreview() {
      this.$router.push({
        name: "TechnologyEvaluation",
        query: { id: this.item.id, preview: true },
      });
    },
    onCancel() {

    }
  },
};
</script>

<style scoped lang="scss">
.left-side {
  min-width: 40px;
  max-width: 40px;
}

.btn-pos {
  position: absolute;
  bottom: 24px;
  right: 24px;
}

.expand-layout {
  -moz-transition: height 0.2s;
  -ms-transition: height 0.2s;
  -o-transition: height 0.2s;
  -webkit-transition: height 0.2s;
  transition: height 0.2s;
  height: 0;
  overflow: hidden;
}

.expand-content {
  padding: 24px;
  background: #fafafa;
  box-shadow: 1px 1px 20px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 20px 20px;
}

.btn-custom {
  width: 15px;
  height: 21px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
}

.height-max {}
</style>
